import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

// eslint-disable-next-line import/no-default-export,react/display-name
export default (props: IconProps) => (
  <IconBox {...props}>
    <path d="M0.312012 41.8755L6.78116 26.6539L15.7399 26.6162L13.2526 32.4551L20.5785 26.6418H26.6757L19.4733 32.6962L23.595 38.0489L28.8782 24.9208H16.2794L17.3265 22.1191H51.505L50.6876 24.9196H37.9912L34.4517 35.0411L42.8891 26.6283H50.7826L49.5644 32.3833L56.1046 26.628H64.312L60.9306 41.8675H52.7544L53.5666 36.5065L47.4598 41.8714H39.8459L40.7586 36.4724L34.9457 41.8793H15.5906L11.5064 36.4987L9.30426 41.8755H0.312012Z" />
  </IconBox>
);
